import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Pagination,
  styled,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  ButtonGroup,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AgentCard from "../../../Shared-ui/SharedComponents/Cards/AgentCard";
import CreateAgent from "../CreateAgent"; // Added missing import
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Agent } from "../../../Shared-ui/Types/Agent";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import SearchIcon from "@mui/icons-material/Search";
import Confirm from "../../../Shared-ui/Types/Confirm";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { AGENT, KNOWLEDGE_BASE } from "../../../Services/Endpoint";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import Agent_emptystateimage from "../../../assets/images/Agents_emptystateimage.svg";
import Menu from "@mui/material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { useSelector } from "react-redux";
import { agentInitial } from "../CreateAgent/AgentInitialData";
import { START_LOADING, STOP_LOADING } from "../../../Shared-ui/Store/LoadingReducer/LoaderTypes";

// Styled Button
const StyledColorButton = styled(Button)(({ theme }) => ({
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
  textTransform: "capitalize",
  fontWeight: 400,
  borderRadius: "8px",
  height: "40px",
  whiteSpace: "nowrap",
}));

const AgentsData = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({
    show: false,
  });
  const [open, setOpen] = useState(false);
  const [agents, setAgents] = useState<Agent[]>([]);
  const [agentsAll, setAgentsAll] = useState<Agent[]>([]);
  const [agent, setAgent] = useState<Agent | null>(null);
  const [searchText, setSearchText] = useState<string>("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(8);
  const prevPage = useRef<number>(page);
  const pageLimitRef = useRef(8);
  const [totalAgents, setTotalAgents] = useState<number>(0);
  const handleOpen = () => setOpen(true);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [filterType, setFilterType] = useState<string>("All Agents");
  const [filteredAgents, setFilteredAgents] = useState<Agent[]>([]);
  const loaderStatus = useSelector((state: any) => state.LoaderReducer);

  // Dropdown state for Create Agent button
  const [createAgentAnchorEl, setCreateAgentAnchorEl] = useState<null | HTMLElement>(null);
  const [createAgentOpen, setCreateAgentOpen] = useState(false);

  const filterMap: any = {
    "All Agents": "all",
    "Created by me": "owned",
    "Shared": "shared",
  };


  // useEffect(() => {
  //   getAgents();
  // }, []);


  useEffect(() => {
    if (prevPage.current !== page) {
      getAgents(filterMap[filterType]);
      prevPage.current = page;
    }
  }, [page, filterType]);

  useEffect(() => {
    if (!searchText) {
      setPage(1);
      getAgents(filterMap[filterType]);
    }
  }, [searchText, filterType]);

  const getAgents = async (filter?: string, searchText?: string) => {
    try {
      dispatch(StartLoading("Agent"));
      var url = `${AGENT}?page=${page}&page_size=${limit}`
      if (filter && filter !== "all") {
        url += `&filter=${filter}`;
      }
      // Apply search if provided
      if (searchText) {
        url += `&search=${searchText}`;
      }
      const data = await BaseInstance.get(url).then((res) => res?.data);
      // data?.items.sort(
      //   (a: { created_at: string }, b: { created_at: string }) =>
      //     new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      // );
      setTotalAgents(data.pagination.total || 0);
      setAgents(data.items || []);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading("Agent"));
    }
  };

  const deleteAgent = async (agent: Agent) => {
    try {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      dispatch(StartLoading());
      const data = await BaseInstance.delete(`${AGENT}/${agent.id}`).then(
        (res) => res?.data
      );
      getAgents(filterType);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  const confirmDelete = (agent: Agent) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure you want to delete the Agent? This action cannot be undone.",
      varient: "delete",
      functionName: deleteAgent,
      functionParam: agent,
    });
  };

  const handleClose = () => {
    setOpen(false);
    getAgents(filterMap[filterType]);
  };

  const editinAgent = (agent: Agent) => {
    setAgent((preVal) => {
      setOpen(true);
      return { ...preVal, ...agent };
    });
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  const handleSearch = () => {
    setPage(1);
    getAgents(filterMap[filterType], searchText);

  };

  const handleFilterPopUp = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClick = (option: number) => {
    setPage(1); // IMPORTANT: reset page when filter changes

    if (option === 0) {
      setFilterType("All Agents");
      getAgents("all");
    } else if (option === 1) {
      setFilterType("Created by me");
      getAgents("owned");
    } else if (option === 2) {
      setFilterType("Shared");
      getAgents("shared");
    }

    setAnchorEl(null);
  };

  const getFilterIcon = (type: string) => {
    switch (type) {
      case "Created by me":
        return <PersonOutlineIcon sx={{ mr: 1, fontSize: 20 }} />;
      case "Shared":
        return <ShareOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />;
      default:
        return <PeopleOutlineIcon sx={{ mr: 1, fontSize: 20 }} />;
    }
  };

  // Dropdown handlers for Create Agent button
  const handleCreateAgentToggle = (event: React.MouseEvent<HTMLElement>) => {
    setCreateAgentAnchorEl(event.currentTarget);
    setCreateAgentOpen((prevOpen) => !prevOpen);
  };

  const handleCreateAgentClose = (event: Event | React.SyntheticEvent) => {
    if (
      createAgentAnchorEl &&
      createAgentAnchorEl.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setCreateAgentOpen(false);
  };

  const handleGraphicView = () => {
    setCreateAgentOpen(false);
    navigate('/agents/create-agent');
  };

  const handlePopupView = () => {
    setCreateAgentOpen(false);
    handleOpen(); // Open the existing popup
  };

  return (
    <Box>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
          flexDirection: { xs: "column", sm: "column", md: "row" },
          gap: { xs: 2, sm: 2, md: 0 },
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography>Filter by:</Typography>
            <Button
              onClick={handleFilterPopUp}
              endIcon={<KeyboardArrowDownIcon />}
              startIcon={getFilterIcon(filterType)}
              sx={{
                textTransform: "none",
                color: "text.primary",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
                display: "flex",
                alignItems: "center",
                "& .MuiButton-startIcon": {
                  marginRight: 0.5,
                },
              }}
            >
              {filterType}
            </Button>
          </Box>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            sx={{
              "& .MuiPaper-root": {
                width: 220,
                boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                borderRadius: "8px",
                mt: 1,
              },
            }}
          >
            <MenuItem onClick={() => handleFilterClick(0)}>
              <PeopleOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
              <Box sx={{ lineHeight: 0 }}>
                <Typography sx={{ lineHeight: "16px" }}>All Agents</Typography>
                <Typography variant="caption" color="text.secondary">
                  View all available agents
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem onClick={() => handleFilterClick(1)}>
              <PersonOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
              <Box sx={{ lineHeight: 0 }}>
                <Typography sx={{ lineHeight: "16px" }}>
                  Created by me
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Agents I created
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem onClick={() => handleFilterClick(2)}>
              <ShareOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
              <Box sx={{ lineHeight: 0 }}>
                <Typography sx={{ lineHeight: "16px" }}>Shared </Typography>
                <Typography variant="caption" color="text.secondary">
                  Agents shared
                </Typography>
              </Box>
            </MenuItem>
          </Menu>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 1, sm: 2 },
            width: { xs: "100%", sm: "100%", md: "auto" },
          }}
        >
          <TextField
            placeholder="Search Agent"
            variant="outlined"
            size="small"
            sx={{
              width: { xs: "100%", sm: "350px" },
              flex: { xs: 1, sm: 1, md: "none" },
            }}
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleSearch} // your custom function
                    edge="end"
                    size="small"
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <ButtonGroup
            variant="contained"
            sx={{
              borderRadius: { sm: "8px", xs: "4px" },
              overflow: "hidden",
              boxShadow: "none",
              "& .MuiButton-root": {
                color: variables.whiteColor,
                textTransform: "capitalize",
                fontWeight: "400",
                whiteSpace: "nowrap",
                backgroundColor: variables.primaryButton,
                "&:hover": {
                  backgroundColor: variables.primaryColor,
                },
              },
              "& .MuiButtonGroup-firstButton": {
                borderRight: `1px solid ${variables.whiteColor}`,
              },
            }}
            size={isSmallScreen ? "small" : "large"}
          >
            <StyledColorButton
              startIcon={<AddIcon />}
              aria-haspopup="menu"
              // onClick={handleCreateAgentToggle}
              onClick={handlePopupView}
              sx={{
                "& .MuiButton-startIcon": {
                  mr: { xs: 0, sm: 1 }
                },
              }}
            >
              {!isSmallScreen && "Create Agent"}
            </StyledColorButton>
            <StyledColorButton
              size="small"
              aria-controls={createAgentOpen ? "create-agent-menu" : undefined}
              aria-expanded={createAgentOpen ? "true" : undefined}
              aria-haspopup="menu"
              onClick={handleCreateAgentToggle}
            >
              <ArrowDropDownIcon />
            </StyledColorButton>
          </ButtonGroup>

          <Popper
            open={createAgentOpen}
            anchorEl={createAgentAnchorEl}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
            sx={{ zIndex: 1500 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === 'bottom-start' ? 'left top' : 'left bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleCreateAgentClose}>
                    <MenuList
                      autoFocusItem={createAgentOpen}
                      id="create-agent-menu"
                      aria-labelledby="create-agent-button"
                    >
                      <MenuItem onClick={handleGraphicView}>
                        Visual Builder
                      </MenuItem>
                      <MenuItem onClick={handlePopupView}>
                        Classic Builder
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </Box>

      {/* Agent Cards Grid */}
      {agents.length > 0 && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xl: "1fr 1fr 1fr 1fr",
              lg: "1fr 1fr 1fr 1fr",
              md: "1fr 1fr 1fr",
              sm: "1fr 1fr",
            },
            gap: 3,
            gridAutoRows: "1fr",
          }}
        >
          {agents.map((agent) => (
            <AgentCard
              key={agent.id}
              agent={agent}
              deleteFun={confirmDelete}
              editFun={editinAgent}
            />
          ))}
        </Box>
      )}


      {agents.length === 0 && totalAgents === 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: 6,
          }}
        >

          {
            loaderStatus.isLoading === false && loaderStatus.pageName === "Agent" && (
              <>
                <img
                  src={Agent_emptystateimage}
                  alt="No Agents"
                  style={{ width: 120, height: "auto" }}
                />
                <Typography variant="h6" color="text.secondary">
                  No Agents Found
                </Typography>
              </>
            )
          }
          {
            loaderStatus.isLoading === true && loaderStatus.pageName === "Agent" && (
              <>
                <img
                  src={Agent_emptystateimage}
                  alt="No Agents"
                  style={{ width: 120, height: "auto" }}
                />
                <Typography variant="h6" color="text.secondary">
                  Agents loading...
                </Typography>
              </>

            )
          }

        </Box>
      )}


      {/* Pagination */}

      {totalAgents > limit && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <Pagination
            count={Math.ceil(totalAgents / limit)}
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
          />
        </Box>
      )}

      {/* Create Agent Dialog */}
      <CreateAgent open={open} handleClose={handleClose} agent={agent} />
      <ConfirmPopup details={confirmPopupData} />
    </Box>
  );
};

export default AgentsData;
